// Scene and transition layers must apply identical tone at the handoff.
export const MEDIA_VIGNETTE = "radial-gradient(ellipse at center, rgba(0,0,0,0) 40%, rgba(0,0,0,0.55) 100%)";
export const HANDOFF_FADE_MS = 120;
